export const FEEDBACK_BAR_LABELS = {
  SLEEP: [
    ["睡眠時間合計", "（夜間）"],
    ["体動が少ない", "睡眠"],
    ["体動が多い", "睡眠"],
  ],
  HEART_BEAT: [
    ["最大レベル", "時間"],
    ["有酸素レベル", "時間"],
    ["歩行レベル", "時間"],
  ],
  TALK: ["朝(6-12時)", "昼(12-18時)", "夜(18-22時)"],
  KCAL: [["消費カロリー", "消費カロリー"]],
  SKIN_TEMPS: [
    ["日中最高温度", ""],
    ["日中最低温度", ""],
    ["日中平均温度", ""],
    ["睡眠時最高温度", ""],
    ["睡眠時最低温度", ""],
    ["睡眠時平均温度", ""],
  ],
};

export const SLEEP_LEGEND_ITEM = {
  id: 1,
  label: "睡眠",
  color: "#46ab9d",
};
export const WALK_LEGEND_ITEM = {
  label: "歩行",
  color: "#1e2679",
};
export const TALK_TV_LEGEND_ITEM = {
  label: "会話・テレビ",
  color: "#c80b4f",
};
export const TALK_TV_LYING_DOWN_LEGEND_ITEM = {
  label: "横になった状態の会話・テレビ",
  color: "#eb709e",
};
export const TALK_EAT_LEGEND_ITEM = {
  label: "歩きながらの会話",
  color: "#ffb801",
};
export const NOT_ACTIVE_LEGEND_ITEM = {
  label: "特に活動していない",
  color: "#afafb1",
};
export const NOT_INSTALLED_LEGEND_ITEM = {
  label: "未装着",
  color: "#71596f",
};

export const LAST_MONTH_LIFE_PATTERN_LEGENDS = [
  [SLEEP_LEGEND_ITEM, TALK_EAT_LEGEND_ITEM],
  [WALK_LEGEND_ITEM, NOT_ACTIVE_LEGEND_ITEM],
  [TALK_TV_LEGEND_ITEM, NOT_INSTALLED_LEGEND_ITEM],
  [TALK_TV_LYING_DOWN_LEGEND_ITEM],
];
